/**
 * 安全導覽工具 — 防止 Open Redirect 漏洞（OWASP A01）
 *
 * 只允許同源相對路徑（以 `/` 開頭、且不以 `//` 開頭的路徑）。
 * 任何外部 URL（https://...）、協定相對路徑（//evil.com）
 * 或 javascript: 偽協定皆會被拒絕，並跳轉至首頁。
 *
 * @param path 目標路徑，必須是同源相對路徑，例如 '/'、'/login'
 */
export function safeNavigate(path: string): void {
  if (
    typeof path !== 'string' ||
    !path.startsWith('/') ||   // 必須以 / 開頭（相對路徑）
    path.startsWith('//')       // 拒絕協定相對 URL（//evil.com）
  ) {
    // 非法目標 → 安全地導向首頁
    window.location.href = '/';
    return;
  }
  window.location.href = path;
}
